<template>
  <div
    v-show="visible"
    class="map-modal"
    :class="{isFullscreen: isFullscreen}"
  >
    <Map
      v-if="visible && lat"
      ref="basicMapbox"
      map-width="100%"
      :map-height="isFullscreen ? '100%' : 'calc(100% - 268px)'"
      :lng="lng"
      :lat="lat"
      :country-code="countryCode"
      :level="level"
      :fieldkey="fieldkey"
      :is-fullscreen="isFullscreen"
      class="mapbox"
    />
    <!-- <i
      class="fullscreen-btn iconfont "
      :class="[isFullscreen ? 'iconicon-test47':'iconicon-test46']"
      @click="handleFullscreen"
    /> -->
    <div
      v-if="timeZone !== undefined"
      class="info-box"
    >
      <p v-if="fieldtype === 'area'">
        <label>{{ $t('message["214"]') }}</label><span class="address"> {{ address }} </span>
      </p>
      <p v-else-if="fieldtype === 'ip'">
        <label>IP地址</label><span> {{ ip }} {{ data.name }}</span>
      </p>
      <p><label>{{ $t('message["1158"]') }}</label>UTC/GMT {{ timeZone > 0 ? '+' : '' }}{{ timeZone }}</p>
      <p>
        <label>{{ $t('message["152"]') }}</label><span v-if="time">{{ moment(time).format('YYYY-MM-DD HH:mm') }}</span> <span
          v-if="week"
          class="week"
        >{{ curDay }}</span>
      </p>
      <p><label>{{ $t('message["422"]') }} </label>{{ (data.area_code && data.area_code.country_code) || '—' }}</p>
      <p><label>{{ $t('message["210"]') }}</label>{{ (data.area_code && data.area_code.area_code) || '—' }}</p>
    </div>
    <div
      v-else-if="!loading"
      class="info-box fs-gray"
    >
      {{ $t('message["626"]') }}
    </div>
    <a
      class="cancel-btn"
      @click="hide"
    >{{ $t('message["896"]') }}</a>
  </div>
</template>
<script>
import moment from 'moment'
import { getInquiryGeo } from '@/services/inqueryServices'
// import Map from './TxMap'
import Map from './Leaflet'
import { getLang } from '@/lib/storage'

export default {
  components: {
    Map
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    lastCode: {
      type: String,
      default: ''
    },
    address: {
      type: String,
      default: ''
    },
    ip: {
      type: String,
      default: ''
    },
    fieldtype: {
      type: String,
      default: ''
    },
    fieldkey: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      data: {},
      lat: '',
      lng: '',
      timeZone: '',
      time: '',
      countryCode: '',
      level: '',
      loading: true,
      isFullscreen: false
    }
  },
  computed: {
    week () {
      let weeks = this.$t('message["945"]').split(',') // ['日', '一', '二', '三', '四', '五', '六']
      let w = moment(this.time).day()
      return this.time ? weeks[w] : ''
    },
    daySelected () {
      return {
        'day': 'Sunday',
        'one': 'Monday',
        'two': 'Tuesday',
        'three': 'Wednesday',
        'four': 'Thursday',
        'five': 'Friday',
        'six': 'Saturday'
      }
    },
    curDay () {
      const lang = this.getLang()
      return lang === 'en' ? this.daySelected[this.week] : '星期' + this.week
    }
  },
  async created () {
    await this.getCenter()

    this.$bus.$on('setFullcreen', (isFullscreen) => {
      this.isFullscreen = isFullscreen
    })
  },
  methods: {
    moment,
    getLang,
    hide () {
      this.$emit('update:visible', false)
    },
    async getCenter () {
      let params = {
        fieldtype: this.fieldtype
      }
      if (this.fieldtype === 'area') {
        params.code = this.lastCode
      } else if (this.fieldtype === 'ip') {
        params.ip = this.ip
      }
      let chain = await getInquiryGeo()
      chain
        .params(params)
        .onSuccess(res => {
          this.loading = false
          // console.log(res)
          if (this.$toType(res) !== 'object') res = {}

          this.data = res || {}
          let { timezone = {}, nowtime } = this.data
          this.lat = timezone.lat || ''
          this.lng = timezone.lng || ''
          this.timeZone = timezone.gmtOffset // 时区
          this.nowtime = nowtime || ''
          this.time = this.timeZone !== undefined ? this.$getLocalTime(this.timeZone, this.nowtime * 1000) : '-'
          this.countryCode = this.data.country_code || ''
          this.level = this.data.level || ''
        })
        .fetch()
    },
    handleFullscreen () {
      this.isFullscreen = !this.isFullscreen

      // this.$refs.basicMapbox && this.$refs.basicMapbox.updateMap()
    }
  }
}
</script>
<style lang="scss" scoped>
.map-modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  height: 100%;
  background-color: #fff;
  &.isFullscreen {
    .mapbox {
      width: 100%;
      height: 100%;
      // transform: rotate(90deg);
      // transform-origin: 50% 50%;
    }
    .info-box {
      display: none;
    }
    .cancel-btn {
      display: none;
    }
  }

  .fullscreen-btn {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 99;
    padding: 10px;
    line-height: 1;
    color: rgba(0,0,0,.7) !important;
  }
}
.info-box {
  position: absolute;
  bottom: 47px;
  left: 0;
  z-index: 3;
  width: 100%;
  padding: 0 12px;
  background-color: #fff;
  p {
    display: flex;
    min-height: 44px;
    line-height: 44px;
    color: #666;
    font-size: 16px;
    border-bottom: solid 1px #DBDBDB;
    &:last-child {
      border: none;
    }
  }
  label {
    display: inline-block;
    width: 80px;
    margin-right: 24px;
    color: #888;
  }
  .address {
    line-height: 24px;
    padding: 6px 0;
  }
  .week {
    margin-left: 12px;
  }
}
.cancel-btn {
  position: absolute;
  bottom: 0;
  left: 0;
  display: block;
  width: 100%;
  height:47px;
  line-height:47px;
  font-size: 16px;
  text-align: center;
  color: #333;
  background:#fafafa;
  border-top: solid 1px #DBDBDB;
}
</style>
